import { render, staticRenderFns } from "./NewOQCUser.vue?vue&type=template&id=5afb9678&scoped=true"
import script from "./NewOQCUser.vue?vue&type=script&lang=js"
export * from "./NewOQCUser.vue?vue&type=script&lang=js"
import style0 from "./NewOQCUser.vue?vue&type=style&index=0&id=5afb9678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb9678",
  null
  
)

export default component.exports